<template>
  <div class="head-title-container">{{ hTitle }}</div>
</template>

<script>
export default {
  props: {
    hTitle: {
      type: String
    }
  }
}
</script>

<style lang="scss">
.head-title-container {
  width: 100%;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #e0e0e0;
  position: relative;
  font-size: 14px;
  color: #343434;
  text-indent: 10px;
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 30px;
    background: #ff8289;
  }
}
</style>
